export function removedToast(name: string): string {
  return `${name.trim()} removed`;
}

export function addedToast(name: string): string {
  return `${name.trim()} added`;
}

export function scoresClearedToast(): string {
  return 'Scores cleared';
}

/** `Amit Bisani checked in` */
export function checkedInToast(name: string): string {
  return `${name.trim()} checked in`;
}

export interface ScoringToastAction {
  label: string;
  run: () => void;
}

/** `Rita Mehta deleted` */
export function deletedToast(name: string): string {
  return `${name.trim()} deleted`;
}

/** `Registration RFL-0091 (Rita Mehta) deleted`, or `Rita Mehta deleted` when there is no code. */
export function registrationDeletedToast(code: string | null | undefined, name: string): string {
  const trimmed = code?.trim() ?? '';
  if (!trimmed) return deletedToast(name);
  return `Registration ${trimmed} (${name.trim()}) deleted`;
}

export function eventDeletedToast(title: string): string {
  return `Event "${title.trim()}" deleted`;
}

export function albumDeletedToast(title: string, photoCount: number): string {
  const count = Math.max(0, photoCount);
  const photos = count === 1 ? '1 photo' : `${count} photos`;
  return `Album "${title.trim()}" and ${photos} deleted`;
}

export function photoDeletedToast(): string {
  return 'Photo deleted';
}

export function pageDeletedToast(title: string): string {
  return `Page "${title.trim()}" deleted`;
}

export function quizCampaignDeletedToast(title: string): string {
  return `Quiz campaign "${title.trim()}" deleted`;
}

export function roundDeletedToast(name: string): string {
  return `Round "${name.trim()}" deleted`;
}

export interface ScoringToast {
  id: number;
  message: string;
  action?: ScoringToastAction;
}

const listeners = new Set<() => void>();
let toasts: ScoringToast[] = [];
let nextId = 1;
const timers = new Map<number, ReturnType<typeof setTimeout>>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function scoringToasts(): ScoringToast[] {
  return toasts;
}

export function subscribeScoringToasts(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function dismissScoringToast(id: number): void {
  const timer = timers.get(id);
  if (timer) clearTimeout(timer);
  timers.delete(id);
  toasts = toasts.filter((toast) => toast.id !== id);
  emit();
}

/** A short confirmation that stays up across the scoring list and shooter pages. */
export function pushScoringToast(message: string, action?: ScoringToastAction, replace = false): void {
  if (replace) {
    for (const timer of timers.values()) clearTimeout(timer);
    timers.clear();
    toasts = [];
  }
  const toast = { id: nextId, message, action };
  nextId += 1;
  toasts = [...toasts, toast];
  emit();
  timers.set(
    toast.id,
    setTimeout(() => dismissScoringToast(toast.id), action ? 12000 : 4500),
  );
}

export function resetScoringToastsForTests(): void {
  for (const timer of timers.values()) clearTimeout(timer);
  timers.clear();
  toasts = [];
  nextId = 1;
  emit();
}
